import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { watchApi } from 'Utils/api';
import {
  fetchWatchesRequest,
  fetchWatchesSuccess,
  fetchWatchesFailure,
} from 'Redux/Slices/WatchSlice';

export const fetchWatchesEpic = (action$: any) =>
  action$.pipe(
    ofType(fetchWatchesRequest.type),
    mergeMap((action: any) =>
      from(watchApi.getWatches(action.payload)).pipe(
        map((response) => fetchWatchesSuccess(response.data.watches)),
        catchError((error) =>
          of(fetchWatchesFailure(error.response?.data?.error || 'Failed to fetch watches'))
        )
      )
    )
  );
